import { render, staticRenderFns } from "./AuthPageTemplate.vue?vue&type=template&id=5bf518a2&scoped=true&"
import script from "./AuthPageTemplate.vue?vue&type=script&lang=js&"
export * from "./AuthPageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AuthPageTemplate.vue?vue&type=style&index=0&id=5bf518a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf518a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFadeTransition,VIcon,VImg,VProgressCircular,VRow})
